import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { DataTypes } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { Modes } from "./mode";
import { EntryTypes } from "./entryType";

export const dateOfNextMaintanance: FieldSchema = {
  grid: {
    displayed: true,
    order: 26,
    ignoredForSearch: true,
  },
  name: "dateOfNextMaintanance",
  data: { type: DataTypes.DATE },
  display: {
    displayed: true,
  },
  validation: {
    // See dateOfLastCalibration: a getter, so "today" is the day the row is validated rather
    // than the day the module happened to be imported.
    minDate: {
      getter: () => new Date(),
      fields: [],
      disabledCache: true,
    },
  },
  form: {
    label: "Next maintenance or calibration",
    type: InputTypes.DATE,
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};
